import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";

const TabPanel = (props) => {
  const { children, value = 0, index = 0, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box py={2}>{children}</Box>
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default React.memo(TabPanel);
